import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptors, withXhr} from "@angular/common/http";
import {routes} from './app.routes';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {httpErrorInterceptor} from "./shared/services/httpIntercepter.service";
import {HistoryPatchService} from "./shared/services/history-patch.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withXhr(), withInterceptors([httpErrorInterceptor])),
    HistoryPatchService]
};
